// extracted by mini-css-extract-plugin
export default {"search-form":"bb_QJ flex-grow-1 form-group mb-0"};